const actions = {
    REFERER_PAYOUT_LIST_BEGIN: 'REFERER_PAYOUT_LIST_BEGIN',
    REFERER_PAYOUT_LIST_SUCCESS: 'REFERER_PAYOUT_LIST_SUCCESS',
    REFERER_PAYOUT_LIST_ERR: 'REFERER_PAYOUT_LIST_ERR',
  
    REFERER_PAYOUT_DETAIL_BEGIN: 'REFERER_PAYOUT_DETAIL_BEGIN',
    REFERER_PAYOUT_DETAIL_SUCCESS: 'REFERER_PAYOUT_DETAIL_SUCCESS',
    REFERER_PAYOUT_DETAIL_ERR: 'REFERER_PAYOUT_DETAIL_ERR',
    
    refererPayoutListingBegin: () => {
      return {
        type: actions.REFERER_PAYOUT_LIST_BEGIN,
      };
    },
    refererPayoutListingSuccess: (data) => {
      return {
        type: actions.REFERER_PAYOUT_LIST_SUCCESS,
        data,
      };
    },
    refererPayoutListingErr: (err) => {
      return {
        type: actions.REFERER_PAYOUT_LIST_ERR,
        err,
      };
    },
    refererPayoutDetailBegin: () => {
      return {
        type: actions.REFERER_PAYOUT_DETAIL_BEGIN,
      };
    },
    refererPayoutDetailSuccess: (data) => {
      return {
        type: actions.REFERER_PAYOUT_DETAIL_SUCCESS,
        data,
      };
    },
    refererPayoutDetailErr: (err) => {
      return {
        type: actions.REFERER_PAYOUT_DETAIL_ERR,
        err,
      };
    },
  };
  export default actions;
  